import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  countReportFiles: 0,
  countReportOrders: 0,
  filesReport : [],
  ordersReport : [],
  pickupsReport: [],
  digitalizationReport: []
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/reports/index.js